import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LucideDynamicIcon } from '@lucide/angular';
import { TextDirective, TextSize, TextWeight } from '../../../typography/text.directive';
import { JoiiIcon } from '../../../icons/lucide/icon';

@Component({
  selector: 'joii-text-icon-cell',
  imports: [TextDirective, LucideDynamicIcon],
  template: `
    @if (prefixIcon(); as prefixIcon) {
      <div joii-text [size]="size()" [weight]="weight()">
        <svg [lucideIcon]="prefixIcon" />
      </div>
    }
    <p joii-text [size]="size()" [weight]="weight()">{{ value() }}</p>
    @if (suffixIcon(); as suffixIcon) {
      <div joii-text [size]="size()" [weight]="weight()">
        <svg [lucideIcon]="suffixIcon" />
      </div>
    }
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: var(--Vetai-Spacing-2);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextIconCellComponent {
  readonly prefixIcon = input<JoiiIcon>();
  readonly suffixIcon = input<JoiiIcon>();
  readonly value = input<string>();
  readonly weight = input<TextWeight>('semibold');
  readonly size = input<TextSize>(4);
}
